import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { useState, useContext, useEffect } from 'react';
import { Stack, Button, Container, Typography, Box } from '@mui/material';

import Iconify from '../components/iconify';
import { ChurchList, ChurchRegistrationForm, ChurchUpdateForm, UserList } from '../sections/diocese/church';
import { authContext } from '../routes';
import { UserUpdateForm } from '../sections/diocese/user';
import CustomSnackbar from '../components/alerts/CustomSnackbar';
import ChurchAvatar from '../sections/commonForChurches/ChurchAvatar';
import DeletedChurchList from '../sections/diocese/church/DeletedChurchList';
import UserPaymentInfo from '../sections/common/UserPaymentInfo';

export default function DioceseChurchPage() {
  const { user } = useContext(authContext);
  const [churchActivatedOn, setChurchActivatedOn] = useState('list');
  const [churchToBeUpdated, setChurchToBeUpdated] = useState(null);
  const [userToBeUpdated, setUserToBeUpdated] = useState(null);
  const [notification, setNotification] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const decodedToken = jwtDecode(token);
      const expirationDate = new Date(decodedToken.exp * 1000);
      if (expirationDate < new Date()) {
        localStorage.clear();
        navigate('/login');
      } else if (user && !user.role.permissions.dioceseChurch.read) {
        navigate('/dashboard');
      }
    } else {
      navigate('/login');
    }
  }, [navigate, user]);

  return (
    <>
      <Helmet>
        <title> አድባራት | የሰ/ሸ/ሃ/መ/አ/ስርዓት </title>
      </Helmet>

      <Container maxWidth="xl">
        {notification.message && <CustomSnackbar notification={notification} setNotification={setNotification} />}
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography  sx={{ fontStyle: 'bold', fontSize:{ sm: 16, md: 20,  lg: 24} , display: { xs: 'none', sm: 'block' } }} color="text.secondary" gutterBottom>
            ተጠሪነታቸው ለሀገረ ስብከት የሆኑ አድባራት
          </Typography>{' '}
          <Typography sx={{ display: { xs: 'block', sm: 'none' } }} color="text.secondary" variant="h4" gutterBottom>
            <Iconify icon="noto:church" />
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'right', gap: { xs: 1, sm: 2 } }}>
            {user && user.role.permissions.church.read && (
              <Button
                disabled={churchActivatedOn && churchActivatedOn === 'list'}
                variant="contained"
                startIcon={<Iconify icon="eva:list-fill" />}
                onClick={() => setChurchActivatedOn('list')}
                color="success"
              >
                <Typography sx={{ display: { xs: 'none', sm: 'block' } }}>የአጥቢያ ዝርዝር</Typography>
              </Button>
            )}

            {user && user.role.permissions.church.create && (
              <Button
                disabled={churchActivatedOn && churchActivatedOn === 'newAdd'}
                variant="contained"
                startIcon={<Iconify icon="eva:plus-fill" />}
                onClick={() => setChurchActivatedOn('newAdd')}
                color="warning"
              >
                <Typography sx={{ display: { xs: 'none', sm: 'block' } }}>አዲስ አጥቢያ</Typography>
              </Button>
            )}
            {user && user.role.permissions.church.delete && (
              <Button
                disabled={churchActivatedOn && churchActivatedOn === 'deletedChurch'}
                color="error"
                variant="contained"
                startIcon={<Iconify icon="eva:trash-2-fill" />}
                onClick={() => setChurchActivatedOn('deletedChurch')}
              >
                <Typography sx={{ display: { xs: 'none', sm: 'block' } }}>የተሰረዙ አጥቢያዎች</Typography>
              </Button>
            )}
          </Box>
        </Stack>

        {churchActivatedOn && churchActivatedOn === 'list' && (
          <ChurchList
            setUserToBeUpdated={setUserToBeUpdated}
            setChurchToBeUpdated={setChurchToBeUpdated}
            setChurchActivatedOn={setChurchActivatedOn}
          />
        )}

        {churchActivatedOn && churchActivatedOn === 'deletedChurch' && (
          <DeletedChurchList
            setUserToBeUpdated={setUserToBeUpdated}
            setChurchToBeUpdated={setChurchToBeUpdated}
            setChurchActivatedOn={setChurchActivatedOn}
          />
        )}

        {churchActivatedOn && churchActivatedOn === 'newAdd' && (
          <ChurchRegistrationForm
            setChurchToBeUpdated={setChurchToBeUpdated}
            setChurchActivatedOn={setChurchActivatedOn}
            notification={notification}
          />
        )}

        {churchActivatedOn && churchActivatedOn === 'churchAvatar' && churchToBeUpdated && (
          <ChurchAvatar
            churchToBeUpdated={churchToBeUpdated}
            setChurchActivatedOn={setChurchActivatedOn}
            notification={notification}
          />
        )}

        {user &&
          user.role.permissions.church.update &&
          churchActivatedOn &&
          churchActivatedOn === 'churchUpdate' &&
          churchToBeUpdated && (
            <ChurchUpdateForm
              churchToBeUpdated={churchToBeUpdated}
              setChurchToBeUpdated={setChurchToBeUpdated}
              user={user}
            />
          )}

        {churchActivatedOn && churchActivatedOn === 'churchUserList' && (
          <UserList
            userToBeUpdated={userToBeUpdated}
            setUserToBeUpdated={setUserToBeUpdated}
            setChurchActivatedOn={setChurchActivatedOn}
          />
        )}

        {churchActivatedOn && churchActivatedOn === 'userUpdate' && (
          <UserUpdateForm userToBeUpdated={userToBeUpdated} setUserToBeUpdated={setUserToBeUpdated} />
        )}
        {churchActivatedOn && userToBeUpdated &&
          churchActivatedOn === 'userPayment' &&
          (
            <UserPaymentInfo userId={userToBeUpdated.id} />
          )}
      </Container>
    </>
  );
}
